"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableClasses = void 0;
var _mui = require("@ori-ui/mui");
const classes = (0, _mui.generateUtilityClasses)('Table', ['headerCell', 'itemCell', 'headerText', 'itemText']);
const tableClasses = exports.tableClasses = {
  ..._mui.tableClasses,
  ...classes
};
